import type { BaseTranslation } from '../i18n-types';

export const message = {
    sidebar: {
        title: 'Messages',
        giftRequested: 'Gift requested',
        gift: 'Gift',
    },
    empty: 'You don’t have any messages yet',
    emptySelected: 'No messages here yet',
    emptyHint: 'You can write to your favorites or find someone in a random chat',
    selectChat: 'Select a chat to start messaging',
    haveUnread: 'You have an unread message',
    haveUnreadHint: 'Buy membership to read messages and chat!',
    buttons: {
        favorite: 'Open favorites',
        start: 'Start video chat',
    },
    clearHistory: {
        button: 'Clear chat history',
        dialogTitle: 'Clear chat history?',
        dialogText: 'All messages will be deleted without possibility to restore',
    },
    call: {
        incoming: 'Incoming call',
        missed: 'Missed call',
        outgoing: 'Outgoing call',
    },
    popup: {
        title: 'New messages',
    },
    emptyConversation: 'No messages here yet',
} satisfies BaseTranslation;
